import { NgClass, NgIf, TitleCasePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import { JoyrideModule } from 'ngx-joyride';
import { NgbDatepickerModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { Angulartics2OnModule } from 'angulartics2';

import { WhatsappToggleModule } from '@tablesready/frontend-whatsapp-toggle';
import {
  CommonRadioGroupModule,
  FormValidationModule,
  PipesModule,
  ShortenedDurationWarningModule,
  TimepickerModule,
  UtilsModule,
} from '@tablesready/common-ui';
import { PartyCustomFieldsModule } from '@tablesready/frontend-party-custom-fields';
import { IonicModule } from '@ionic/angular';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { FrontendDropdownClearComponent, FrontendDropdownModule } from '@tablesready/frontend-dropdown';
import { FrontendModalModule } from '@tablesready/frontend-modal';
import { OverlayModule } from '@angular/cdk/overlay';
import { PartyCustomerInfoModule } from '@tablesready/frontend-party-customer-info';
import { FrontendSizeInputComponent } from '@tablesready/frontend-size-input';
import { AddEditPartyComponent } from './add-edit-party.component';
import { SizeModule } from '../size/size.module';
import { DurationModule } from '../duration/duration.module';

@NgModule({
  declarations: [
    AddEditPartyComponent,
  ],
  exports: [
    AddEditPartyComponent,
  ],
  imports: [
    FrontendIconsModule,
    FormValidationModule,
    FormsModule,
    ReactiveFormsModule,
    UtilsModule,
    NgClass,
    JoyrideModule.forChild(),
    WhatsappToggleModule,
    CommonRadioGroupModule,
    NgbDatepickerModule,
    TimepickerModule,
    NgSelectModule,
    Angulartics2OnModule,
    NgIf,
    TitleCasePipe,
    NgbTooltipModule,
    PipesModule,
    PartyCustomFieldsModule,
    IonicModule,
    FrontendDropdownModule,
    FrontendDropdownClearComponent,
    FrontendModalModule,
    OverlayModule,
    PartyCustomerInfoModule,
    SizeModule,
    DurationModule,
    FrontendSizeInputComponent,
    ShortenedDurationWarningModule,
  ],
})
export class AddEditPartyModule {}
